<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">home</span>
      <h2>Tableau de bord</h2>
    </div>

    <p class="section-intro">
      Le tableau de bord est la page d'accueil du système. Il affiche un résumé visuel
      de l'activité avec les indicateurs clés. <strong>Accès :</strong> tous les utilisateurs.
    </p>

    <h3 class="sub-title">Éléments affichés</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Élément</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Cartes de synthèse</strong></td><td>En haut de la page : nombre de commandes du jour, chiffre d'affaires du jour, nombre de produits en stock, etc.</td></tr>
          <tr><td><strong>Graphiques</strong></td><td>Évolution du chiffre d'affaires, répartition des ventes par produit ou par client.</td></tr>
          <tr><td><strong>Dernières opérations</strong></td><td>Liste des dernières commandes, derniers paiements et derniers mouvements de stock.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#6cbd7e">lightbulb</span>
        Astuce
      </div>
      <p>
        Pour revenir au tableau de bord à tout moment, cliquez sur l'icône <strong>Accueil</strong> (maison) dans le menu latéral gauche.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocTableauDeBord" };
</script>
